<template>
    <div>
        <section v-if="!initialLoading">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table
                            id="data-table-list-users"
                            class="table table-hover-animation table-striped table-bordered"
                        >
                            <caption>
                                Lista de usuarios
                            </caption>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Fecha de registro</th>
                                    <th scope="col">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(user, index) in this.users"
                                    v-bind:key="index"
                                >
                                    <td>
                                        <p style="width: 15px">{{ index + 1 }}</p>
                                    </td>
                                    <td>
                                        <p style="width: 220px">{{ user.name }}</p>
                                    </td>
                                    <td>
                                        <p style="width: 220px">{{ moment(user.created_at).format('DD/MM/YYYY hh:mm A') }}</p>
                                    </td>
                                    <td>
                                        <button class="btn btn-primary" @click="deleteDialog(user)">Eliminar</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <el-dialog
                    v-model="showDeleteDialog"
                    title="Eliminar usuario del curso"
                    width="40%"
                >
                    <span class="text-danger" style="word-break: normal;">Al eliminar este registro se eliminará el registro de pagos y, en caso de 
                        que el curso sea parte de una oferta, se eliminará también los cursos incluidos en dicha oferta
                    </span>
                    <div>
                        ¿Desea eliminar a <strong>{{ this.userSelected.name }}</strong> de este curso?
                    </div>
                    <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="showDeleteDialog = false">Cancelar</el-button>
                        <el-button type="primary" @click="deleteUser()">
                        Confirmar
                        </el-button>
                    </span>
                    </template>
                </el-dialog>
            </div>
        </section>
    </div>
</template>
<script>
import moment from 'moment';
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

export default {
    data() {
        return {
            initialLoading: false,
            users: [],
            moment: moment,
            showDeleteDialog: false,
            userSelected: [],
        };
    },
    props:{
        course_id: Number,
    },
    mounted() {
        this.listUsers();
    },

    methods: {
        deleteDialog(user){
            this.userSelected = user;
            this.showDeleteDialog = true;
        },
        async deleteUser(){
            await axios.delete(`/course/payment/${this.userSelected.payment_id}/delete`).then((response) => {
                this.showDeleteDialog = false
                this.$message.success("El usuario se elimino de curso correctamente");
                this.listUsers();
            })
        },
        closeModal(id) {
            $(`#${id}`).modal("hide");
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-users").DataTable(language);
            });
        },
        listUsers: function () {
            this.initialLoading = true;
            axios.get(`/course/${this.course_id}/users/get`).then((response) => {
                this.users = response.data;
                this.initialLoading = false;
                this.loadDataTable();
            });
        },
    },
};
</script>
<style>
.el-icon {
    width: 20px;
}
.el-select .el-input .el-select__caret::before {
    display: none !important;
}
.el-icon .el-select__caret .el-select__icon {
    transform: rotateZ(0deg);
}
#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
